// extracted by mini-css-extract-plugin
module.exports = {"page":"PageWrapper_page__2vnBq","pageNumber":"PageWrapper_pageNumber__DAmfH","text":"PageWrapper_text__1bvVF","innerPage":"PageWrapper_innerPage__2NHFa"};